import type { LeadStatus } from '@embrace-returns/shared';

// Internal status values stay 'New' | 'Closed'; users see the pass-on language.
export const STATUS_LABEL: Record<LeadStatus, string> = {
  New: 'To pass on',
  Closed: 'Passed on',
};
